import { FC, memo } from "react";
import { IconProps } from "./types";
import { getPreparedSvgProps } from "./utils";
import { Svg } from "baseui/icon/styled-components";

const TwitterIcon: FC<IconProps> = ({ title, ...props }) => {
  const svgProps = getPreparedSvgProps(props);

  return (
    <Svg {...props} {...svgProps} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title>{title}</title>}
      <path d="M11.5476 25.7523C20.6042 25.7523 25.5578 18.2489 25.5578 11.7421C25.5578 11.529 25.5578 11.3168 25.5434 11.1056C26.5071 10.4086 27.3389 9.54552 28 8.55682C27.1013 8.95502 26.148 9.21622 25.1718 9.33152C26.1997 8.71612 26.969 7.74822 27.3366 6.60802C26.37 7.18162 25.3126 7.58582 24.2099 7.80322C22.3451 5.82032 19.2259 5.72462 17.243 7.58942C15.9642 8.79202 15.4216 10.5841 15.8185 12.2941C11.8594 12.0956 8.17056 10.2256 5.67026 7.14952C4.36336 9.39942 5.03086 12.2777 7.19476 13.7226C6.41116 13.6994 5.64466 13.488 4.95986 13.1063V13.1687C4.96046 15.5126 6.61276 17.5315 8.91026 17.9956C8.18536 18.1933 7.42476 18.2222 6.68686 18.0801C7.33196 20.0859 9.18056 21.4601 11.2872 21.4996C9.54356 22.8699 7.38966 23.6138 5.17196 23.6116C4.78016 23.6108 4.38876 23.5871 3.99976 23.5406C6.25156 24.9857 8.87166 25.7522 11.5473 25.7486" />
    </Svg>
  );
};

export default memo(TwitterIcon);
